import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { graphql } from "@repo/graphql-types";
import Left from "@repo/icons/default/Left";

import { AppointmentReceivingOptionsForm } from "@/components/appointment/appointment-receiving-options-form";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { FullPageSpinner } from "@/components/ui/loading/full-page-spinner";
import { PendingComponent } from "@/components/ui/loading/pending-component";
import { useGraphQL } from "@/hooks/use-graphql";

import type { JSX } from "react";

const AppointmentReceivingOptionsCreatePageQuery = graphql(/* GraphQL */ `
  query AppointmentReceivingOptionsCreatePageQuery($codUsuarioFormaRecebimento: Int!) {
    ...AppointmentReceivingOptionsFormQueryFragment
  }
`);

const appointmentReceivingOptionSchema = z.object({
  action: z.string().optional(),
});

const AppointmentReceivingOptionsCreatePage = (): JSX.Element => {
  const queryResult = useGraphQL(AppointmentReceivingOptionsCreatePageQuery, {
    codUsuarioFormaRecebimento: -1,
  });

  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Novo convênio" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? <AppointmentReceivingOptionsForm data={data} /> : <FullPageSpinner />}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/appointment-receiving-options/create/",
)({
  component: AppointmentReceivingOptionsCreatePage,
  pendingComponent: () => <PendingComponent title="Novo convênio" />,
  validateSearch: appointmentReceivingOptionSchema,
});
